//React
import React from "react"
import { Link, useNavigate } from "react-router-dom"
//Components
import ListItem from "../../../Components/ListItem"

export default function EnquiryList({ enquiries }) {
  const navigate = useNavigate()
  return (
    <div>
      <h3 className="ps- mb-3">Enquiries</h3>
      <hr />
      {enquiries && enquiries.length > 0 ? (
        enquiries.map((enquiry) => (
          <div
            key={enquiry.id}
            className="row ps-2 mb-2  p-2 hoverMe innerCon"
            onClick={() =>
              navigate(`../../enquiries/view_enquiry/${enquiry.id}`)
            }
            >
                <div className="col-11">
                    {new Date(enquiry.dateOfQuery).toLocaleDateString("en-GB")} - <Link to={`/enquiries/view_enquiry/${enquiry.id}`}>{enquiry.title ? enquiry.title : "" }</Link> - {enquiry.groupName}<br/>
                    {enquiry.groupType}, {enquiry.parish}
                </div>
                <div className="col-1">
                  <button className="btn btn-primary">View</button>
                </div>
          </div>
        ))
      ) : (
        <div className="mb-3 text-center ">No enquiries found.</div>
      )}
    </div>
  )
}
